import React from 'react';
import { Button, Spin, Pagination } from 'antd';
import { connect } from 'dva';
import styles from './Table.less';
import ColGroup from './ColGroup.js';
import Order from './Order.js';

@connect(({ merchantOrder, loading }) => ({
  loading: loading.effects['merchantOrder/fetchDataSource'],
  dataSource: merchantOrder.dataSource,
  pagination: merchantOrder.pagination,
}))
export default class Record extends React.Component {
  constructor(props) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  handleExport() {
    const { dispatch } = this.props;
    dispatch({
      type: 'merchantOrder/exportOrder',
    });
  }

  handleTableChange(page, pageSize) {
    const pagination = {
      current: page,
      pageSize,
    };

    this.props.dispatch({
      type: 'merchantOrder/savePagination',
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    if (this.props.onChange) {
      this.props.onChange(pagination);
    }
  }

  render() {
    const { loading, dataSource } = this.props;

    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      current: this.props.pagination.current,
      total: this.props.pagination.total,
    };

    return (
      <div className={styles.root}>
        <div className="table-operation-buttons-wraps">
          <Button type="primary" onClick={this.handleExport}>
            导出
          </Button>
        </div>
        <Spin spinning={loading}>
          <div className="order-table">
            <table className="table-title">
              <ColGroup />
              <tbody>
                <tr>
                  <th>商品</th>
                  <th className="price">价格</th>
                  <th className="pay-user">付款人</th>
                  <th className="time">支付时间</th>
                  <th className="status">订单状态</th>
                  <th className="actual-price">实付金额</th>
                </tr>
              </tbody>
            </table>
          </div>

          {dataSource.map(order => <Order key={order.orderNo} data={order} />)}

          <div className="order-pagination">
            <Pagination
              {...pagination}
              onChange={this.handleTableChange}
              onShowSizeChange={this.handleTableChange}
            />
          </div>
        </Spin>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Order/Table/Table.js